import React, { useState } from "react";
import VideoModal from "../components/VideoModal";
import "../styles/Pages.css";
import "../styles/HariParamrut.css";

const VIDEOS = [
  {
    id: "BVzyYp3vdOQ",
    title: "Swadharm Ki Sargam",
  },
  {
    id: "OonOxOcTihg",
    title: "Akshar Yatra Ki Gatha",
  },
  {
    id: "APA9iPJhy_U",
    title: "Avya Anirdeshi",
  },
  {
    id: "cRFYBItF728",
    title: "Kem Visaru Prem Aa Taro",
  },
  {
    id: "iLm1NTkj2Mc",
    title: "The Way He Loves",
  },
  {
    id: "-phh-RoKC8c",
    title: "Karuna Ke Agadh Sagar",
  },
];

function HariPrasangDarshan() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState(null);

  const openVideoModal = (videoId, title) => {
    setSelectedVideoId(videoId);
    setSelectedVideoTitle(title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedVideoId(null);
    setSelectedVideoTitle(null);
  };

  return (
    <main className="page-content pravachan-page">
      <section className="page-header">
        <h1 className="section-title">Hari Smruti Darshan</h1>
        <p className="header-subtitle">
          Guruhari P.P. Hariprasad Swamiji Prasang & Smruti Darshan
        </p>
      </section>

      <section className="page-body">
        <div className="video-grid">
          {VIDEOS.map((video, index) => (
            <div
              key={index}
              className="video-card"
              onClick={() => openVideoModal(video.id, video.title)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter") openVideoModal(video.id, video.title);
              }}
            >
              <div className="video-thumbnail">
                <img
                  src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                  alt={video.title}
                />
                <div className="play-overlay">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
              <div className="video-info">
                <h3>{video.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {isModalOpen && (
        <VideoModal
          videoId={selectedVideoId}
          title={selectedVideoTitle}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}
    </main>
  );
}

export default HariPrasangDarshan;
